<template>
  <div class="p-top">
    <!-- メインビジュアル -->
    <div class="p-top__mv">
      <mv ref="mv"></mv>
    </div>
    
    <!-- コンセプト文 -->
    <div id="p-top__lead" class="p-top__lead">
      <lead ref="lead"></lead>
    </div>

    <!-- カテゴリ -->
    <div class="p-top__cat">

      <div class="c-category c-category--1">
        <div class="c-category__text" data-ref="categoryThumb1">
          <span></span>
        </div>
        
        <category-thumb ref="categoryThumb1" category="gold" max="3"></category-thumb>

        <div class="c-category__info">
          <h2>
            <span>GOLD</span>
            <span>K18</span>
          </h2>
          <template v-if="$store.getters.lang === 'en'">
            <p>G-22 series</p>
          </template>
          <template v-else>
            <p>G-22 series</p>
          </template>
          <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}gold/`"
          >
            <span>Detail</span>
          </router-link>
        </div>
      </div>

      <div class="c-category c-category--2">
        <div class="c-category__text" data-ref="categoryThumb2">
          <span></span>
        </div>
        
        <category-thumb ref="categoryThumb2" category="tortoiseshell" max="3"></category-thumb>

        <div class="c-category__info">
          <h2>
            <span>TORTOISESHELL</span>
            <span v-if="$store.getters.lang === 'ja'">鼈甲</span>
          </h2>
          <template v-if="$store.getters.lang === 'en'">
            <p>NP-10B series / S-647T series</p>
          </template>
          <template v-else>
            <p>NP-10B series / S-647T series</p>
          </template>
          <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}tortoiseshell/`"
          >
            <span>Detail</span>
          </router-link>
        </div>
      </div>

      <div class="c-category c-category--3">
        <div class="c-category__text" data-ref="categoryThumb3">
          <span></span>
        </div>
        
        <category-thumb ref="categoryThumb3" category="buffalohorn" max="3"></category-thumb>

        <div class="c-category__info">
          <h2>
            <span>BUFFALO HORN</span>
            <span v-if="$store.getters.lang === 'ja'">バッファローホーン</span>
          </h2>
          <template v-if="$store.getters.lang === 'en'">
            <p>NP-16BF series</p>
          </template>
          <template v-else>
            <p>NP-16BF series</p>
          </template>
          <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}buffalohorn/`"
          >
            <span>Detail</span>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 商品 -->
    <div class="p-top__prod">
      <lineup></lineup>
    </div>
  </div>
</template>

<script>
import Mv from '@/_components/top/Mv';
import Lead from '@/_components/top/Lead';
import CategoryThumb from '@/_components/top/CategoryThumb';
import Lineup from '@/_components/Lineup';
import { gsap, Quart } from 'gsap';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// gsap
gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

export default {
  components: {
    Mv,
    Lead,
    Lineup,
    CategoryThumb,
  },
  data() {
    return {
      ScrollSmoother: null,
      ispc: false,
      scrollObjects: [],
      resizeObserver: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 初期設定
      vm.once();
    });
  },
  beforeRouteLeave(to, from, next) {
    // loading表示
    this.$store.commit('setShowLoad', true);
    
    setTimeout(() => {
      this.reset();
      next();
    }, this.$store.getters.loadTime * 1000);
  },
  beforeRouteUpdate (to, form, next) {
    next();
  },
  mounted() {},
  methods: {
    once() {
      this.resizeObserver = new ResizeObserver(this.resize);
      this.resizeObserver.observe(document.body);
      this.$nextTick(this.start);

      this.$emit('child-ready', '準備完了');
    },
    start() {
      this.$store.commit('setShowLoad', false);

      this.resize();

      this.slideshow();

      setTimeout(() => {
        this.$refs['mv'].start();
      }, 1000);
    },
    slideshow() {
      
    },
    setting() {
      let triggers = ScrollTrigger.getAll();
      triggers.forEach(function (trigger) {
          trigger.kill();
      });

      //if (gFNS.isDevice === 'pc') {
        //////////
        // gsap SmoothScroller
        //////////
        this.ScrollSmoother = ScrollSmoother.create({
          effects: false,
          smooth: 0.7,
          smoothTouch: 0.1,
          ignoreMobileResize: true,
          normalizeScroll: true,
          //onUpdate: this.scroll,
        });
      //}

      //////////
      // gsap ScrollTrigger
      //////////
      ScrollTrigger.normalizeScroll(true);
      
      // ヘッダー
      ScrollTrigger.create({
        trigger: '#p-top__lead',
        start: 'top top',
        scrub: true,
        ease: 'none',
        onToggle: (self) => {
          if (self.isActive || self.direction === 1) {
            this.$store.commit('setHeadBlack', true);
          } else {
            this.$store.commit('setHeadBlack', false);
          }
        },
      });

      // MV 
      this.scrollObjects.push('.c-mv__thumb');
      const tlmv = gsap.timeline();
      tlmv.to('.c-mv__thumb', {y: '50%', ease: 'none'});

      ScrollTrigger.create({
        animation: tlmv,
        trigger: '#c-mv',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        ease: 'none',
      });

      // コンセプト文
      this.scrollObjects.push('#p-top__lead');
      this.scrollObjects.push('#c-lead__info');

      ScrollTrigger.create({
        trigger: '#p-top__lead',
        start: 'top top+=50%',
        scrub: true,
        ease: 'none',
        once: true,
        toggleClass: 'p-top__lead--toggle',
      });

      document.getElementById('c-lead__info').querySelectorAll('h2,p').forEach(wrap => {
        gsap.set(wrap, {
          scale: 1.1,
          y: '100%', 
          autoAlpha: 0, 
          filter: 'blur(10px)',
          webkitFilter: 'blur(10px)'
        });

        gsap.to(wrap, {
          scale: 1.0,
          y: '0%',
          autoAlpha: 1,
          filter: 'blur(0px)',
          webkitFilter: 'blur(0px)',
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: 'bottom top+=85%',
            ease: Quart.easeOut,
            scrub: true,
          }
        })
      });

      // カテゴリー
      this.scrollObjects.push('.c-category__text');
      this.scrollObjects.push('.c-category__thumb');
      this.scrollObjects.push('.c-category__info');

      gsap.utils.toArray('.c-category__text').forEach(wrap => {
        gsap.to(wrap, {
          y: '-50%',
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: 'bottom top',
            //ease: 'none',
            scrub: true,
          }
        });

        gsap.set(wrap, {
          scrollTrigger: {
            trigger: wrap,
            start: 'top center+=20%',
            scrub: true,
            once: true,
            toggleClass: 'c-category__text--toggle',
            onToggle: (self) => {
              if (self.isActive && self.direction === 1) {
                const refName = self.trigger.getAttribute('data-ref');
                this.$refs[refName].start();
              }
            }
          }
        });
      });

      gsap.utils.toArray('.c-category__info').forEach(wrap => {
        gsap.to(wrap, {
          y: '-30%',
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: 'bottom top',
            //ease: 'none',
            scrub: true,
          }
        })
      });

      document.querySelectorAll('.c-category__thumb').forEach(thumb => {
        const wrap = thumb.querySelector('.is-wrap');
        const img = thumb.querySelector('.is-wrap-image');
        const diff = wrap.getBoundingClientRect().height - thumb.getBoundingClientRect().height;

        wrap.style.top = -diff + 'px';
        gsap.killTweensOf(img);
        gsap.to(img, {
          y: diff,
          ease: 'none',
          scrollTrigger: {
            trigger: thumb,
            start: 'top bottom',
            end: 'bottom top',
            //ease: 'none',
            scrub: true,
          }
        })
      });

      // LINE UP
      this.scrollObjects.push('.c-product__text');

      gsap.set('.c-product__text', {
        scrollTrigger: {
          trigger: '.c-product__text',
          start: 'top center+=20%',
          scrub: true,
          //markers: true,
          once: true,
          toggleClass: 'c-product__text--toggle',
        }
      });
    },
    settingPC() {
      ScrollTrigger.refresh();
      ScrollTrigger.update();
    },
    settingSP() {
      ScrollTrigger.refresh();
      ScrollTrigger.update();
    },
    resize() {
      if (this.checkSP(900)) {
        // sp
        if (this.ispc) {
          this.ispc = false;
          this.settingSP();
        }
      } else {
        // pc
        if (!this.ispc) {
          this.ispc = true;
          this.settingPC();
        }
      }

      this.setting();
    },
    checkSP(breakpoint) {
      return window.matchMedia('(max-width: ' + breakpoint +'px)').matches;
    },
    scroll(scroller) {
      // console.log(scroller);
      // console.log(this.scrollTop(), scroller.scrollTop());
    },
    scrollTop() {
      return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
    },
    reset() {
      window.scrollTo(0, 0);
      this.resizeObserver.unobserve(document.body);
      this.resizeObserver.disconnect();

      if (this.ScrollSmoother) {
        this.ScrollSmoother.scrollTo(0, 0);
        this.ScrollSmoother.kill();
        this.ScrollSmoother = null;
        window.scrollTo(0, 0);
      }

      let triggers = ScrollTrigger.getAll();
      triggers.forEach(function (trigger) {
          trigger.kill();
      });

      this.scrollObjects.forEach((el) => {
        if (el === '.c-category__thumb') {
          gsap.set(`${el} .is-wrap`, {clearProps: true});
          gsap.set(`${el} .is-wrap-image`, {clearProps: true});
        } else {
          gsap.set(el, {clearProps: true});
        }
      });
      this.scrollObjects = [];

      this.$refs['categoryThumb1'].reset();
      this.$refs['categoryThumb2'].reset();
      this.$refs['categoryThumb3'].reset();

      this.$store.commit('setHeadBlack', false);

      this.$refs['mv'].reset();
    }
  }
}
</script>